import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNetworkKey, getSpaceKey, getSpacePostTypeKey, getSpacePostTypesKey, getSpacesKey, } from '../../utils/keys';
export const useUpdateSpacePostTypes = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.spacePostType.update(input, fields), {
        onSettled: (data, error, variables) => {
            const spacePostTypesKey = getSpacePostTypesKey({
                variables: {
                    spaceId: variables === null || variables === void 0 ? void 0 : variables.spaceId,
                },
            });
            queryClient.invalidateQueries(spacePostTypesKey);
            const spacePostTypeKey = getSpacePostTypeKey({
                variables: {
                    spaceId: variables === null || variables === void 0 ? void 0 : variables.spaceId,
                },
            });
            queryClient.invalidateQueries(spacePostTypeKey);
            queryClient.invalidateQueries(getSpacesKey());
            queryClient.invalidateQueries(getSpaceKey());
            queryClient.invalidateQueries(getNetworkKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateSpacePostTypes.js.map